module.exports = __webpack_public_path__ + "media/images/athletes/3540-3b0aa0f77f4d82aea30edc51349c4221.png";